const baseUrl = 'https://res.cloudinary.com/rehabpath/image/upload'

function getCloudinaryUrl(imagePath, transformations) {
  if (imagePath.charAt(0) === '/') imagePath = imagePath.substring(1)
  return `${baseUrl}/${transformations}/f_auto/${imagePath}`
}

export default getCloudinaryUrl
